import AboutContent from "./AboutContent";

export default AboutContent;